import { Component, Output, EventEmitter, Input, SimpleChanges } from '@angular/core';
import { Observable } from 'rxjs';
import { FormControl } from '@angular/forms';
import { map, startWith } from 'rxjs/operators';
import { DatePipe } from '@angular/common';
import { AsapService } from 'app/@core/lib/asap.service';

@Component({
    selector: 'app-user-filters',
    templateUrl: './filters.component.html',
    providers: [AsapService]
})

export class UserFiltersComponent {

    @Input() filter: any = {};
    @Input() clear: boolean = false;
    @Output() onSearch = new EventEmitter();
    @Output() currentClear: EventEmitter<boolean> = new EventEmitter();


    //public clear:number = 0;
    public fields;
    public ufs;
    public cities: any;
    public filteredCities: Observable<string[]>;
    public myControl = new FormControl();

    public fieldDataType: any;

    public faixasAnosIntervaloDe: any = [];
    public faixasAnosIntervaloAte: any = [];
    public FaixasAnos: any = {};
    public showFieldDataTytpe = false;

    constructor(public service: AsapService) {
        this.loadFields();
        this.loadUF();

    }

    ngOnChanges(changes: SimpleChanges) {
        console.log(changes)
        if (this.clear == true) {
            console.log(this.filter)
            this.filter = {};
            this.clear = false;
            this.loadFields();
        }

        if (changes.filter) {
            if (!this.filter) {
                this.filter = {};
            }
        }
    }

    public SetFaixasAnos() {
        console.log(this.FaixasAnos)
    }
    public filtraCidades() {
        this.filteredCities = this.myControl.valueChanges
            .pipe(
                startWith(''),
                map(value => this._filter(value))
            );
    }
    private _filter(value: string): string[] {
        const filterValue = value.toLowerCase();
        return this.cities.filter(option => option.nome.toLowerCase().includes(filterValue));
    }
    public loadFields() {

        this.FaixasAnos = {
            from: '',
            to: '',
            type: 'date'
        }

        this.fieldDataType = localStorage.getItem('fieldDataType') ? localStorage.getItem('fieldDataType') : 1;

        //this.faixasAnosIntervaloDe = Array(50).fill(1).map((x, y) => (new Date().getFullYear()-50) - y);
        //this.faixasAnosIntervaloAte =  this.faixasAnosIntervaloDe.map((x, y) => (x+1));
        this.service.basePath = "api/v2";
        this.service.entityName = "admin/user/form";
        this.service.getResources().subscribe((response: any) => {
            console.log("[FiltersComponent]", response);
            this.fields = response.data.map((item) => {
                // if(item.select_filter==1) {
                if (item.type == "select") {
                    if ((item.options.length == 0) || (item.options[0] == 'base')) {
                        this.service.basePath = "api/v2";
                        this.service.entityName = "admin/user/form/values/" + item.name;
                        this.service.getResources().subscribe((response: any) => {
                            console.log("[FiltersComponent.FieldValues]", response);
                            item.options = response.data;
                        });
                    }
                } else if ((item.type == "number") || (item.type == "date")) {
                    this.setFieldDataTytpe(item.name);
                    this.filter[item.name] = {
                        from: '',
                        to: '',
                        type: item.type
                    };
                }

                return item;
                // }
            });
            console.log("fields", this.fields)
            console.log(this.filter)

        });
    }

    public loadUF() {
        console.log(this.filter)
        this.service.http.get("https://servicodados.ibge.gov.br/api/v1/localidades/estados").subscribe((response) => {
            console.log("[loadUF]", response);
            this.ufs = response;
        });
    }

    public loadCities(event) {
        //this.filter.cidade = null;
        let uf = this.ufs.find((item) => item.sigla == event.value);
        if (uf) {
            this.service.http.get("https://servicodados.ibge.gov.br/api/v1/localidades/estados/" + uf.sigla + "/municipios").subscribe((response) => {
                //console.log("[loadCities]",response);
                this.cities = response;
                this.filtraCidades();
                this.search()
            });
        }
    }
    public setFieldDataTytpe(campo) {
        localStorage.setItem('fieldDataType', this.fieldDataType);
        if (this.filter) {
            this.filter[campo] = this.FaixasAnos;
            console.log(campo);
        }
    }

    public search() {
        let tmp_filter = {};
        console.log(this.filter)
        if (Object.keys(this.filter).length > 0) {
            if (this.filter) {
                Object.keys(this.filter).map((item) => {
                    if (this.filter[item]) {
                        console.log('type', item, this.filter[item], typeof this.filter[item])
                        if ((typeof this.filter[item] === 'string') && this.filter[item].length) {
                            // tmp_filter[item[0]] = this.filter[item].replace('-','');
                            tmp_filter[item] = this.filter[item];
                            //VERIFICA SE O CAMPO É UM RANGE de/ate
                        } else if (typeof this.filter[item] === 'object') {
                            console.log("length", this.filter[item].length)
                            if (this.filter[item].length > 1) {
                                tmp_filter[item] = this.filter[item][0] + '[AND]' + this.filter[item][1];
                            } else {
                                tmp_filter[item] = this.filter[item][0];
                            }
                            //VERIFICA SE O CAMPO É UM RANGE DE NUMEROS INTEIROS
                            if (this.filter[item].type == 'number') {
                                if (this.filter[item].from.length) {
                                    tmp_filter[item] = this.filter[item].from + '⋅' + this.filter[item].to;
                                }

                                //VERIFICA SE O CAMPO É UM RANGE DE DATAS
                            } else if (this.filter[item].type == 'date') {
                                //VERIFICA SE AS DUAS POSIÇÕES DO RANGE ESTAO PREENCHIDAS (DE/ATE)
                                if (this.filter[item].from.toString().length && this.filter[item].to.toString().length) {
                                    //VERIFICA SE É COMPOSTO APENAS POR 4 DIGITOS(ANO) OU DATA COMPLETA (DE/ATE)
                                    if (this.filter[item].from.toString().length == 4) {
                                        tmp_filter[item] = this.filter[item].from + '-01-01' + '|' + this.filter[item].to + '-12-31';
                                    } else {
                                        tmp_filter[item] = new DatePipe('en').transform(this.filter[item].from, 'yyyy-MM-dd') + '|' + new DatePipe('en').transform(this.filter[item].to, 'yyyy-MM-dd');
                                    }

                                    //SE APENAS UMA, É UMA DATA UNICA (DE/DE)
                                } else if (this.filter[item].from.toString().length && (this.filter[item].to.toString().length == 0)) {
                                    tmp_filter[item] = new DatePipe('en').transform(this.filter[item].from, 'yyyy-MM-dd') + '|' + new DatePipe('en').transform(this.filter[item].from, 'yyyy-MM-dd');
                                }
                                console.log(tmp_filter[item])

                            }
                        }
                    }
                })
            }
            console.log(tmp_filter)
            this.onSearch.emit(tmp_filter);
            this.currentClear.emit(true);
        }
        else {
            this.onSearch.emit(null);
        }
    }

}



// WEBPACK FOOTER //
// ./src/app/shared/user-filters/filters.component.ts